import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setLocalItem } from '@/utils/localStorage.util';
import { isTvUserAgent } from '@/utils/tv.util';
// Providers
import Providers from './providers';
// StyleSheets
import '@/styles/global.css';

// Flag Smart-TV user agents on <html> before first paint (no flash) so the
// `html.tv-mode` global styles scale the 10-foot UI up app-wide.
if (isTvUserAgent()) {
    document.documentElement.classList.add('tv-mode');
}

const staticAccessToken = import.meta.env.VITE_STATIC_ACCESS_TOKEN;
const staticRefreshToken = import.meta.env.VITE_STATIC_REFRESH_TOKEN;

if (staticAccessToken) {
    setLocalItem('accessToken', staticAccessToken);
}

if (staticRefreshToken) {
    setLocalItem('refreshToken', staticRefreshToken);
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.querySelector('#root')!).render(
    <StrictMode>
        <Providers />
    </StrictMode>,
);
